import React from 'react';
import { useDispatch } from 'react-redux';
import { WithPermission } from 'Common/Components/WithPermission';
import { FEATURE_WORKSPACES, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { openModal } from 'store/modals/actions';
import { MODAL_WORKSPACE_CREATE } from 'store/modals/modals';
import { useIntl } from 'react-intl';
import { AddButton } from 'shared/ui';

// eslint-disable-next-line import/prefer-default-export
export const WsAddButton = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  return (
    <WithPermission permission={ FEATURE_WORKSPACES } type={ PERMISSION_TYPES.CREATE }>
      <AddButton title="Create Workspace" onClick={ () => dispatch(openModal(MODAL_WORKSPACE_CREATE)) }>
          {intl.formatMessage({ id: 'common.button.add.workspace' }) }
      </AddButton>
    </WithPermission>
  );
};
